import { Component, OnInit, inject } from '@angular/core';
import { LoaderService } from 'app/services/loader.service';
import { ActivatedRoute } from '@angular/router';
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { ProfileMyInfoComponent } from './profile-myinfo.component';

@Component({
    templateUrl: './profile.component.html',
    imports: [MenuComponent, ProfileMyInfoComponent]
})
export class ProfileComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private loaderService = inject(LoaderService);


  public subMenuItems = [
    {key :'myinfo', title: 'My Profile'},
    {key :'resetpassword', title: 'Change Password'},
  ];

  ngOnInit(): void{
    this.route.params.subscribe(
      params => {
        this.loaderService.navigateTo.next(params['tag']);
      }
    );
  }
}